/**
 * Returns if the current url is equal to result page.
 */
const isResultUrl = (location: any = window.location) => {
  return location.pathname.includes('/result');
};

export default isResultUrl;
